import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bulb"
const BulbIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2h2v3h-2V2ZM9 16.569v.917l6-1v-.07c.2-.382.441-.778.686-1.179.645-1.06 1.314-2.156 1.314-3.16C17 9.273 14.761 7 12 7s-5 2.273-5 5.077c0 1.578.792 2.72 1.484 3.718.185.266.362.523.516.774ZM14 22v-1.32l-4 .667V22h4Zm1-2.5-6 1v-2l6-1v2Zm4-8.5h3v2h-3v-2ZM5 11H2v2h3v-2Zm.636-6.778 2.121 2.121-1.414 1.414-2.121-2.121 1.414-1.414Zm12.728 0-2.121 2.121 1.414 1.414 2.121-2.121-1.414-1.414Z"
      />
    </svg>
  )
}
export default BulbIcon
